<script lang="ts">
  // Globaler Mini-Toast-Stack unten rechts fuer atomare Background-
  // Aktionen (Storage-Restore, kuenftig Agent-Redeploy etc.). Jeder
  // Eintrag ist eine kleine Pille: "läuft" mit Spinner, "fertig" mit
  // Haken, "fehlgeschlagen" mit Warn-Icon. Auto-dismiss durch den
  // job-toasts-Store.
  import { jobs, type JobToast } from "./job-toasts.svelte";

  const list = jobs();
  const visible = $derived(Array.from(list.values()));

  function pillClass(j: JobToast): string {
    if (j.phase === "done") return "border-success/30 bg-success/10 text-success";
    if (j.phase === "failed") return "border-danger/30 bg-danger/10 text-danger";
    return "border-border bg-bg-muted/80 text-fg";
  }
</script>

{#if visible.length > 0}
  <div class="fixed bottom-4 right-4 z-50 flex flex-col gap-2 pointer-events-none">
    {#each visible as j (j.id)}
      <div class="surface pointer-events-auto flex items-start gap-2.5 rounded-lg border px-3 py-2 shadow-md text-xs min-w-[260px] max-w-md {pillClass(j)}">
        <span class="mt-0.5 shrink-0">
          {#if j.phase === "running"}
            <svg class="h-3.5 w-3.5 animate-spin" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <circle cx="12" cy="12" r="9" stroke-opacity="0.25"/>
              <path d="M21 12a9 9 0 0 0-9-9"/>
            </svg>
          {:else if j.phase === "done"}
            <svg class="h-3.5 w-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="m5 12 5 5L20 7"/>
            </svg>
          {:else}
            <svg class="h-3.5 w-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z"/>
              <path d="M12 9v4"/><path d="M12 17h.01"/>
            </svg>
          {/if}
        </span>
        <div class="min-w-0 grid gap-0.5">
          <div class="text-fg truncate font-medium">{j.label}</div>
          {#if j.message}
            <div class="text-fg-muted truncate t-meta">{j.message}</div>
          {/if}
        </div>
      </div>
    {/each}
  </div>
{/if}
